/**
 *
 * Created by adalto on 5/15/14.
 */


Greenmile.RouteDetail = Greenmile.RouteDetail || {};
Greenmile.RouteDetail.ColumnsToGrid = (function () {

    function ColumnsToGrid () {

        Greenmile.GridColumns.Stop.apply(this, arguments);

        this.url = 'form/RouteDetail/index';

        this.getFieldsToGridLayout = function (callback) {

            var error = null,
                ajax  = null;

            try {

                App.Forms.RouteDetail = App.Forms.RouteDetail || {};

                if (!App.Forms.RouteDetail.layout) {

                    ajax = new Monet.Ajax();
                    ajax.url = this.url;
                    ajax.success = function (context) {
                        return function (data) {
                            if (data) {
                                App.Forms.RouteDetail.layout = {};
                                App.Forms.RouteDetail.layout.index = data;
                                App.Forms[context.entity].layout = App.Forms.RouteDetail.layout;
                            }

                            if (callback) {
                              callback();
                            }
                        };
                    }(this);

                    ajax.error = function (response) {
                        Monet.Configurations.errorNotification(null, response);
                    };

                    ajax.send();

                } else {
                    App.Forms[this.entity].layout = App.Forms.RouteDetail.layout;
                    if (callback) {
                      callback();
                    }
                }

            } catch (e) {
                error = new Monet.Exception.ReturnError(this,
                    'Error on get grid layout on route detail');
                error.console();
            }

        };

    }

    return ColumnsToGrid;

})();
